import { useContext, useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {useCookies} from 'react-cookie';
import axios from 'axios';
import { base_url } from '../url_variables';
import { BarLoader, ClockLoader } from 'react-spinners';
import '../styling/backdrop.css';
// import Lightbox from "yet-another-react-lightbox-lite";
// import "yet-another-react-lightbox-lite/styles.css";
import { TostMessageContext } from "../context/TostMessage";

export function ProductDetails({ showModal, setShowModal, showDetails }) {
    const [pageLoading, setPageLoading] = useState(false);
    const [cookies, ] = useCookies();
    const [cartItems, setCartItems] = useState([]);
        // const [open, setOpen] = React.useState(false);
    const [stockQty, setStockQty] = useState({});

    useEffect(() => {
        getData();
    }, [])

    useEffect(() => {
        if (!cartItems?.length) return;

        const stockMap = {};

        cartItems.forEach(item => {
            stockMap[item.product_id] = getStock(item.product_id);
        });

        setStockQty(stockMap);
    }, [cartItems]);

    async function getStock(prod_id) {
        const formData = new FormData();
        formData.append('product_id', prod_id);
        try {
            const response = await axios.post(base_url + '/get_item_stock.php', formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: cookies?.userProfile?.session,
                    accountid: cookies?.userProfile?.main_id,
                },
            });
            if (response.data.status) {
                return response.data.in_stock;
            } else {
                return 'N/A'
            }
        } catch (error) {
          return 'N/A'
        }
    }

    async function getData() {
        const formData = new FormData();
        formData.append('customer', showDetails?.email);

        setPageLoading(true)
        try {
            const response = await axios.post(base_url + '/get_customer_cart.php', formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: cookies?.userProfile?.session,
                    accountid: cookies?.userProfile?.main_id,
                },
            });
            if (response.data.status) {
                setCartItems(response.data.records)
            } else {

            }
            setPageLoading(false)
        } catch (error) {
            setPageLoading(false)
        }
    }

    useEffect(() => {
        if (pageLoading) return;

    }, [pageLoading]);


  return (
        <div className='backdrop flex justify-center items-center w-fill-available h-full fixed top-0'>
            <div className='flex flex-col items-center py-7 px-5 h-full overflow-y-auto w-[100%] lg:w-[50%] fixed right-0 bg-white animate-scaleIn'>
                <div onClick={() => setShowModal(false)} className='fixed z-[99] w-auto self-end flex justify-end text-underline text-[#ff0000] cursor-pointer'>Close</div>
                <a className='text-dark text-[20px] font-bold'>{'Customer Cart'}</a>
                {pageLoading &&
                    <div className="h-full w-full bg-white flex items-center justify-center">
                        <BarLoader 
                            color={'#7d5af6'}
                            loading={true}
                            size={10}
                            aria-label="Loading Spinner"
                            data-testid="loader"
                        />
                    </div>
                }
                {!pageLoading &&
                <>
                    <div className="w-full space-y-6 mt-5">
                    {cartItems?.map((item, index) => (
                        <div
                            key={index}
                            className="flex flex-col md:flex-row md:items-center gap-4 md:gap-6 border rounded-lg p-4"
                        >
                            {/* Product */}
                            <div className="flex items-center gap-4 md:w-1/3">
                            <img
                                src={item.thumbnail}
                                alt={item.name}
                                className="w-16 h-16 object-contain"
                            />

                            <div className='w-auto'>
                                <p className="font-medium">{item.name}</p>
                            </div>
                            </div>
                            
                            {/* Quantity */}
                            {/* <div className="md:w-1/6">
                            <input
                                type="number"
                                min="1"
                                value={item.quantity}
                                onChange={(e) =>
                                updateQty(index, Number(e.target.value))
                                }
                                className="w-20 border rounded px-2 py-1"
                            />
                            </div> */}

                            {/* Subtotal */}
                            <div className="md:w-1/6 font-medium">
                            <p className='text-xs md:text-sm font-regular text-[#585858]'>In Cart</p>
                            {item.quantity}
                            </div>

                            {/* In Stock */}
                            <div className="md:w-1/6 font-medium">
                            <p className='text-xs md:text-sm font-regular text-[#585858]'>In Stock</p>
                            {stockQty?.[item.product_id] ?? 'Checking stock..'}
                            </div>

                        </div>
                        ))}
                    </div>
                </>
                }
            </div>  
        </div>
    )
}
